import type { Grade } from 'ts-fsrs';
import { Check, ChevronRight, RotateCcw } from 'lucide-react';
import type { IntervalPreview } from '../lib/scheduling';
import { RatingPanel } from './rating-panel';

interface PageRatingProps {
  intervals: IntervalPreview[];
  rate: (rating: Grade) => void;
  isRating: boolean;
  rated: boolean;
  resetRated: () => void;
  remainingDueCount: number;
  onNextDuePage: () => void;
  focusedPage?: string;
}

export function PageRating({
  intervals,
  rate,
  isRating,
  rated,
  resetRated,
  remainingDueCount,
  onNextDuePage,
  focusedPage,
}: PageRatingProps) {
  if (rated) {
    return (
      <div className="flex flex-col gap-2.5 px-4 py-3">
        {remainingDueCount > 0 && (
          <button
            type="button"
            onClick={onNextDuePage}
            className="inline-flex items-center justify-center gap-1.5 rounded-xl bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 active:bg-primary/80"
          >
            Next due page
            <ChevronRight className="h-4 w-4" />
          </button>
        )}
        <div className="flex items-center justify-center gap-2">
          <span className="inline-flex items-center gap-1 rounded-full border border-border bg-accent/30 px-2.5 py-1 text-xs text-muted-foreground">
            <Check className="h-3 w-3" />
            Rated
          </span>
          <button
            type="button"
            onClick={resetRated}
            className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs text-muted-foreground transition-colors hover:text-foreground hover:bg-accent/50"
          >
            <RotateCcw className="h-3 w-3" />
            Redo
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 pt-4 pb-3">
      {focusedPage && (
        <div className="flex justify-center mb-2">
          <span className="rounded-full bg-primary/10 px-2.5 py-0.5 text-[11px] font-medium text-primary">
            p. {focusedPage}
          </span>
        </div>
      )}
      <RatingPanel intervals={intervals} onRate={rate} disabled={isRating} />
    </div>
  );
}
